var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "1000", persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c("v-icon", [_vm._v("business")]),
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.form.id
                      ? _vm.$t("parametro.crud.editParametro")
                      : "Editar"
                  ) +
                  "\n        "
              ),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  on: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _vm._v("\n          Datos Básicos\n\n          "),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_de_documentos,
                                  "item-text": "descripcion",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Tipo de documento"
                                },
                                model: {
                                  value: _vm.persona.id_tipo_documento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona,
                                      "id_tipo_documento",
                                      $$v
                                    )
                                  },
                                  expression: "persona.id_tipo_documento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs3: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Número de Documento",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "50"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.obtenerNrodoc()
                                  }
                                },
                                model: {
                                  value: _vm.persona.nro_doc,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "nro_doc", $$v)
                                  },
                                  expression: "persona.nro_doc"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Complemento",
                                  id: "complemento",
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.nro_complemento,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona,
                                      "nro_complemento",
                                      $$v
                                    )
                                  },
                                  expression: "persona.nro_complemento"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.tipo_expedido,
                                  "item-text": "valor",
                                  "item-value": "valor",
                                  rules: _vm.$validate(["required"]),
                                  label: "Expedido en"
                                },
                                model: {
                                  value: _vm.persona.expedido,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "expedido", $$v)
                                  },
                                  expression: "persona.expedido"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md2: "" } },
                            [
                              _c("v-autocomplete", {
                                attrs: {
                                  items: _vm.sexos,
                                  "item-text": "valor",
                                  "item-value": function(val) {
                                    return parseInt(val.id)
                                  },
                                  label: "Sexo",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.persona.id_parametro_sexo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona,
                                      "id_parametro_sexo",
                                      $$v
                                    )
                                  },
                                  expression: "persona.id_parametro_sexo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Paterno",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_paterno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_paterno", $$v)
                                  },
                                  expression: "persona.ap_paterno"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Materno",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_materno,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_materno", $$v)
                                  },
                                  expression: "persona.ap_materno"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Apellido Casada",
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.ap_casada,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "ap_casada", $$v)
                                  },
                                  expression: "persona.ap_casada"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mayuscula",
                                attrs: {
                                  label: "Nombres",
                                  rules: _vm.$validate(["required"]),
                                  required: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.nombres,
                                  callback: function($$v) {
                                    _vm.$set(_vm.persona, "nombres", $$v)
                                  },
                                  expression: "persona.nombres"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v("\n          Usuario\n          "),
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nombre Usuario",
                                  disabled: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.usuarios[0].nombre_usuario,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona.usuarios[0],
                                      "nombre_usuario",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "persona.usuarios[0].nombre_usuario"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Correo Electrónico",
                                  disabled: "",
                                  maxlength: "50"
                                },
                                model: {
                                  value: _vm.persona.usuarios[0].correo,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.persona.usuarios[0],
                                      "correo",
                                      $$v
                                    )
                                  },
                                  expression: "persona.usuarios[0].correo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n          "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        disabled: !_vm.valid,
                        loading: _vm.loading
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.save")) + "\n          "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9dcf46ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9dcf46ac","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/persona/dialogs/EditarPersona.vue
// module id = null
// module chunks = 